angular.module('vastdesk')
.component('nativeCreativeFileUploader', {
  bindings: {
    formName: '@',
    formId: '@',
    fieldName: '@',
    creativeAction: '@',
    creativeRemoteUrl: '@',
    custom: '<',
    customCode: '@',
    width: '<',
    height: '<',
    tilesTemplate: '@',
    templateMap: '<',
    objectPersisted: '<',
    childAttributes: '<'
  },
  template: require("../templates/nativeCreativeFileUploader.html"),
  controllerAs: '$nativeCreativeFileUploaderCtrl',
  controller: ['$scope', '$element', function($scope, $element) {
    var self = this;
    var defaultFileSelectedText = 'No file chosen';
    this.fileSelected = defaultFileSelectedText;

    this.creativeOptions = [
      {value: 'file', label: 'File'},
      {value: 'url', label: 'URL'}
    ];

    this.creativeOptionTooltip = function(val, child) {
      if (val === 'url') {
        return child.tooltipText;
      }
    };

    this.$onInit = function() {
      this.templateOptions = Object.keys(this.templateMap);
      if (self.customCode) {
        self.decodedCustomCode = self.customCode.replaceAll('%7B%7B', '{{').replaceAll('%7D%7D', '}}');
      }

      this.categoryOptions = this.templateOptions.map(function(key) {
        return { value: key, label: self.templateMap[key].label };
      });
      this.selectedCategory = self.tilesTemplate;

      self.onTilesTemplateChange(self.tilesTemplate);
      self.populateUnsavedChildFields();
    };

    // If the object failed to save we want to repopulate the type selector and url fields.
    this.populateUnsavedChildFields = function() {
      this.children.forEach((child, index) => {
        var attrs = this.childAttributes && this.childAttributes[index];
        child.creativeAction = (attrs && attrs.creative_action) || self.creativeAction;
        child.value = (attrs && attrs.value) || '';
      });
    };

    this.onTilesTemplateChange = function(template) {
      self.tilesTemplate = template;
      $scope.$parent.tilesTemplate = template;
      $scope.$parent.isImmersive = !!(self.templateMap[template] && self.templateMap[template].group === 'immersive');
      $scope.$parent.hasEndcard = $scope.$parent.isImmersive && self.templateMap[template].has_endcard;
      self.setChildren();
      self.add_file_input_change_listeners();
    };

    this.onCategoryChange = function(category) {
      self.selectedCategory = category;
      self.onTilesTemplateChange(category);
    };

    this.setTooltipText = function(child) {
      child.tooltipText = child.valid_file_formats.length > 0 ? `File type must be ${child.valid_file_formats.join(', ')}. Size limit is 500mb` : null;
    };

    this.setChildren = function() {
      // Clone child objects so we don't mutate the shared TILES_TEMPLATE_MAPPINGS constant
      this.children = ((this.templateMap[this.tilesTemplate] || {}).children || []).map(c => ({ ...c }));
      this.children.forEach((child, index) => {
        child.creativeAction   = self.creativeAction;
        child.fileSelected     = defaultFileSelectedText;
        child.fileInputFieldId = `child_file_input_${index}`;
        child.fileInputName    = `${self.formName}[creatives][]`;
        child.urlInputName     = `${self.formName}[creative_remote_urls][]`;
        this.setTooltipText(child);
      });
    };

    this.uploadLabel = function(child) {
      if (child.label) {
        return child.label + ' Upload From:';
      }
      switch (child.class) {
        case 'NativeImageCreative':
          return 'Image Upload From:';
        case 'NativeVideoCreative':
          return 'Video Upload From:';
        default:
          return 'Upload From:';
      }
    };

    this.$onDestroy = function() {
      $element.find('[id^="child_file_input_"]').off('change');
    };

    this.add_file_input_change_listeners = function() {
      setTimeout(() => {
        self.children.forEach(child => {
          if (child.hasFileInputListener) {
            return;
          }
          child.hasFileInputListener = true;
          $element.find('#' + child.fileInputFieldId).on('change', function() {
            if (this.files[0] && this.files[0].size > 500000000) {
              child.fileSelected = defaultFileSelectedText;
              child.errorMessage = 'File is too large';
              $('#' + child.fileInputFieldId).val('');
            }
            else {
              child.fileSelected = 'File selected!';
              child.errorMessage = null;
            }

            $scope.$apply();
          });
        });
      }, 0);
    };
  }]
});
